/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

// Client-only state for the chat feature, keyed by `${role}:${chatId}`.
// Messages and server-side read state live in RTK Query (chat.api.slice).
// This slice tracks UI state (open/closed) and a client-cached lastReadId
// for instant unread-badge updates while the markChatRead mutation flies.

const initialEntry = {
  open: false,
  lastReadId: null,
};

const keyOf = (role, chatId) => `${role}:${chatId}`;

const chatSlice = createSlice({
  name: "chat",
  initialState: { byKey: {} },
  reducers: {
    setOpen: {
      reducer(state, { payload: { key, open } }) {
        if (!state.byKey[key]) state.byKey[key] = { ...initialEntry };
        state.byKey[key].open = open;
      },
      prepare: ({ role, chatId, open }) => ({
        payload: { key: keyOf(role, chatId), open },
      }),
    },
    setLastRead: {
      reducer(state, { payload: { key, lastReadId } }) {
        if (!state.byKey[key]) state.byKey[key] = { ...initialEntry };
        state.byKey[key].lastReadId = lastReadId;
      },
      prepare: ({ role, chatId, lastReadId }) => ({
        payload: { key: keyOf(role, chatId), lastReadId },
      }),
    },
  },
});

export const selectChatEntry = (role, chatId) => (state) =>
  state.chat.byKey[keyOf(role, chatId)] || initialEntry;

export const { setOpen, setLastRead } = chatSlice.actions;

export default chatSlice.reducer;
